<div class="d-flex justify-content-between align-items-baseline">
  <h2 class="m-0" translate>Cart</h2>
  <!-- actions -->
  <cart-orders-actions #orderAction
    [config]="actionsConf"
    (clearAll)="onRemoveAll()"
    (updateAll)="onUpdateAll()">
  </cart-orders-actions>
  <!-- /actions -->
</div>

@if (!isProductsAmountWithinRange) {
  <p class="text-danger" >
    <span translate> The products amount should be smaller than </span>
    {{cartProductLimitCount}}
  </p>
}

<!-- table -->
<table class="table mt-2 mb-0">
  <thead class="hidden-medium-down">
    <tr>
      @if (!hideProductImageBox) {
        <th></th>
      }
      <th translate>Description</th>
      <th translate>Price</th>
      <th class="text-center quantity-th" translate>Quantity</th>
      <th translate>Total</th>
      <th></th>
    </tr>
  </thead>
  @for (item of items.TransactionItems | ProductPipe: 'ParentLineId': null; track item) {
    <tbody
      class="item-wrap transaction-items"
      [ngClass]="{'kit-open': item.isOpen}">
      <!-- transaction-items -->
      <tr class="parent-row">
        <!-- desktop-view -->
        @if (!hideProductImageBox) {
          <td class="hidden-medium-down item-picture" (click)="goToProductPage(item)">
            <img product-image
              [product]="item"
              [size]="'Sma'"
              class="img-fluid"/>
            <div class="item-title d-inline-block pl-2 pr-2"></div>
          </td>
        }
        <td class="hidden-medium-down td_desc" (click)="goToProductPage(item)">
          <div class="d-flex">
            <div>
              <p class="tem-description mb-0" [innerHtml]="item.ItemDescription"></p>
              <p class="mb-0 text-muted"><span translate>Barcode</span>: {{item.Barcode}}</p>
            </div>&nbsp;&nbsp;&nbsp;
            @if (item.children.length) {
              <div (click)="$event.preventDefault(); $event.stopPropagation();" class="show-kit-btn text-center f-s-20 hidden-medium-down">
                <span (click)="item.isOpen =! item.isOpen;">
                  @if (!item.isOpen) {
                    <i class="fa fa-angle-down" tooltip="{{'Show items in kit'|translate}}"></i>
                  }
                  @if (item.isOpen) {
                    <i class="fa fa-angle-up" tooltip="{{'Hide'|translate}}"></i>
                  }
                </span>
              </div>
            }
          </div>
        </td>
        <td class="hidden-medium-down">
          <div translate>{{item.PricePerItem?.value !== -1 ? (item.PricePerItem.value | currency:item.PricePerItem.currency:'symbol') : 'POA'}}</div>
          @if (item.PricePerItem?.striped !== -1) {
            <div class="striped-price">{{item.PricePerItem?.striped | currency:item.PricePerItem.currency:'symbol'}}</div>
          }
        </td>
        <td class="hidden-medium-down text-center d-flex justify-content-center align-items-center flex-column" (click)="$event.preventDefault(); $event.stopPropagation();">
          <quantity-selector class="d-flex justify-content-center" [id]="item['ProductID']" [quantity]="item['FixedLotMultiplier']" [value]="item['ItemQuantity']" (qtyChanged)="onQtyChanged($event)"></quantity-selector>
          <button
            type="button"
            class="btn"
            (click)="onUpdateCart(item['ProductID'] )"
            tooltip="{{'Update Price'|translate}}">
            <i class="fa fa-refresh" style="color: #999"></i>
            <span translate class="app-primary-color">Update</span>
          </button>
        </td>
        <td class="hidden-medium-down">{{item.PricePerItem?.currency ?  (item.TotalPrice | currency:item.PricePerItem.currency:'symbol') : item.TotalPrice}}</td>
        <td class="hidden-medium-down actions-wrap text-right">
          <button
            type="button"
            class="remove-btn p-0 bg-transparent border-0"
            (click)="onRemoveItem(item); $event.stopPropagation();"
            tooltip="{{'Remove'|translate}}">
            <i class="fa-solid fa-trash pe-1 ps-0"></i>
            <span translate>Remove</span>
          </button>
        </td>
        <!-- end desktop-view -->
        <!-- mobile-view -->
        <td class="d-md-none mobile-view">
          <div class="row py-3">
            <div class="col-auto">
              @if (!hideProductImageBox) {
                <div class="item-picture" (click)="goToProductPage(item)">
                  <img product-image
                    [product]="item"
                    [size]="'Sma'"
                    class="img-fluid"/>
                </div>
              }
            </div>
            <div class="col mx-2">
              <div (click)="goToProductPage(item)">
                <strong class="item-title item-description mb-0">{{item.ItemDescription}}</strong>
                <p class="mb-2 text-muted"><span translate>Barcode</span>: {{item.Barcode}}</p>
              </div>
            </div>
            <div class="col-auto px-2">
              <!--<i class="ion-icon ion-close color-grey-500" (click)="onRemoveItem(item)"></i>-->
              <i class="fa fa-trash color-grey-700 f-s-20" (click)="onRemoveItem(item)"></i>
            </div>
            @if (item.children.length) {
              <div class="td_kit col-12" (click)="$event.preventDefault(); $event.stopPropagation();">
                <div (click)="item.isOpen =! item.isOpen;" class="mt-2 app-primary-text">
                  @if (!item.isOpen) {
                    <span>
                      <span translate>Show items in kit</span>&nbsp;
                      <i class="fa fa-plus-circle"></i>
                    </span>
                  }
                  @if (item.isOpen) {
                    <span>
                      <span translate>Items in kit</span>&nbsp;
                      <i class="fa fa-minus-circle"></i>
                    </span>
                  }
                </div>
                <div [hidden]="!item.isOpen" class="mt-3">
                  <ng-container *ngTemplateOutlet="kitDetails"></ng-container>
                </div>
              </div>
            }
            @if ((item.PricePerItem?.value == -1 || (!item.Stock || item.Stock < item.ItemQuantity) && inventoryCheck) || item.ExstraData.note) {
              <div class="col-12">
                <ul class="product-notes small mt-4 p-0 list-unstyled">
                  @if (item.PricePerItem?.value == -1) {
                    <li class="d-flex align-items-baseline text-danger">
                      <span class="font-weight-medium" translate>Price does not exist</span>
                    </li>
                  }
                  @if (inventoryCheck && item.Stock <= 0) {
                    <li class="d-flex align-items-baseline text-danger">
                      <span class="font-weight-medium" translate>The product is not in stock</span>
                    </li>
                  }
                  @if (inventoryCheck && item?.Stock < item.ItemQuantity) {
                    <li class="d-flex align-items-baseline text-danger">
                      <span class="font-weight-medium" translate>The product quantity is bigger than stock</span>
                    </li>
                  }
                  @if (item.ExstraData.note) {
                    <li class="d-flex align-items-baseline text-danger">
                      <span class="font-weight-medium">{{item.ExstraData.note}}</span>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
          <div class="row">
            <div class="col-12">
              <p class="border-top-1 fw-bold mb-0 py-3 d-flex justify-content-between">
                <span class="app-primary-text"><span translate>Quantity</span>:</span>
                <quantity-selector [id]="item['ProductID']" [quantity]="item['FixedLotMultiplier']" [value]="item['ItemQuantity']" (qtyChanged)="onQtyChanged($event)"></quantity-selector>
              </p>
              <p class="border-top-1 fw-bold mb-0 py-3">
                <span class="app-primary-text" translate>Price</span>:
                <span class="pull-right" translate>{{item.PricePerItem?.value !== -1 ? (item.PricePerItem.value | currency:item.PricePerItem?.currency:'symbol') : 'POA'}}</span>
                @if (item.PricePerItem?.striped !== -1) {
                  <span class="text-right striped-price d-block">{{item.PricePerItem?.striped | currency:item.PricePerItem.currency:'symbol'}}</span>
                }
              </p>
              <p class="border-top-1 fw-bold mb-0 py-3">
                <span class="app-primary-text" translate>Total Price</span>:
                <span class="pull-right">{{item.PricePerItem.currency ?  (item.TotalPrice | currency:item.PricePerItem.currency:'symbol') : item.TotalPrice}}</span>
              </p>
            </div>
          </div>
        </td>
        <!-- end mobile-view -->
      </tr>
      <tr [hidden]="!item.isOpen" (click)="goToProductPage(item)" class="kit-row hidden-medium-down">
        <td colspan="7" class="p-30">
          <table class="d-none">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th translate>Quantity</th>
              </tr>
            </thead>
            <tbody>
              @for (kit of item.children; track kit) {
                <tr>
                  <td class="hidden-medium-down item-picture">
                    <img product-image
                      [product]="kit"
                      [size]="'Sma'"
                      class="img-fluid"/>
                    <div class="item-title d-inline-block pl-2 pr-2"></div>
                  </td>
                  <td class="hidden-medium-down">
                    <p class="tem-description mb-0" [innerHtml]="kit.ItemDescription"></p>
                    <p class="mb-0 text-muted"><span translate>Barcode</span>: {{kit.Barcode}}</p>
                  </td>
                  <td>
                    <p>{{kit.ItemQuantity}}</p>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <ng-container *ngTemplateOutlet="kitDetails"></ng-container>
        </td>
      </tr>
      <tr class="hidden-medium-down">
        <td colspan="6" class="pt-0">
          @if ((item.PricePerItem?.value == -1 || (!item.Stock || item.Stock < item.ItemQuantity) && inventoryCheck) || item.ExstraData.note) {
            <ul class="product-notes small p-0 list-unstyled">
              @if (item.PricePerItem?.value == -1) {
                <li class="d-flex align-items-baseline text-danger">
                  <span class="font-weight-medium" translate>Price does not exist</span>
                </li>
              }
              @if (inventoryCheck && item.Stock <= 0) {
                <li class="d-flex align-items-baseline text-danger">
                  <span class="font-weight-medium" translate>The product is not in stock</span>
                </li>
              }
              @if (inventoryCheck && item?.Stock < item.ItemQuantity) {
                <li class="d-flex align-items-baseline text-danger">
                  <span class="font-weight-medium" translate>The product quantity is bigger than stock</span>
                </li>
              }
              @if (item.ExstraData.note) {
                <li class="d-flex align-items-baseline text-danger">
                  <span class="font-weight-medium" translate>{{item.ExstraData.note}}</span>
                </li>
              }
            </ul>
          }
        </td>
      </tr>
      <ng-template #kitDetails>
        <ul class="p-0 m-0">
          @for (kit of item.children; track kit) {
            <li class="d-flex align-items-center mb-2">
              <div class="item-picture">
                <img product-image
                  [product]="kit"
                  [size]="'Sma'"
                  class="img-fluid"/>
                <div class="item-title d-inline-block pl-2 pr-2"></div>
              </div>
              <div class="">
                <p class="tem-description mb-0" [innerHtml]="kit.ItemDescription"></p>
                <p class="mb-0 text-muted"><span translate>Barcode</span>: {{kit.Barcode}}</p>
              </div>
              <div class="f-s-20 px-4">&times;</div>
              <div>
                {{kit.ItemQuantity}}
              </div>
            </li>
          }
        </ul>
      </ng-template>
    </tbody>
  }
</table>
@if (!isProductsAmountWithinRange) {
  <p class="text-danger" >
    <span translate> The products amount should be smaller than </span>
    {{cartProductLimitCount}}
  </p>
}
<!-- /table -->
